export default __webpack_public_path__ + "static/2743-777d2ec0a3cc8e07d560a4053b3ac677.jpeg";